import Sortable from 'sortablejs';
import { getWindowWidth } from "../DomUtilities/ElementsUtil";

export default class SortElementsByDrag {
	private readonly TABLET_BREAKPOINT: number = 700;

	constructor(parentElement: HTMLElement) {
		const delay: number = getWindowWidth() > this.TABLET_BREAKPOINT ? 10 : 80;

		new Sortable(parentElement, {
			animation: 500,
			dragClass: "drag-over",
			delay: delay
		});
	}
}
